enum DisbursalTypeEnum {
    Drawdown = 'DRAWDOWN',
    Full = 'FULL',
}

export default DisbursalTypeEnum;
